import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MyDataRequestDocsDTO  {
    _originalTypeClassName = "zERP.BO.MyDataRequestDocsDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MyDataRequestDocsDTO.translate = translateService;
}
this.Mark = null;
this.EntityVatNumber = null;
this.DateFrom = null;
this.DateTo = null;
this.ReceiverVatNumber = null;
this.InvType = null;
this.MaxMark = null;
this.NextPartitionKey = null;
this.NextRowKey = null;
this.MyDataRequestDocsDTOKey = null;
this._key = this.MyDataRequestDocsDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Mark:any;
EntityVatNumber:any;
DateFrom:any;
DateTo:any;
ReceiverVatNumber:any;
InvType:any;
MaxMark:any;
NextPartitionKey:any;
NextRowKey:any;
private _MyDataRequestDocsDTOKey:any;
get MyDataRequestDocsDTOKey(): any {
    return this._MyDataRequestDocsDTOKey;
  }
set MyDataRequestDocsDTOKey(value: any) {
    this._MyDataRequestDocsDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MyDataRequestDocsDTOKey == null || $this.MyDataRequestDocsDTOKey == 0;
            }


}